<template>
    <div class="rules-nav">
        <nav>
            <ul>
                <li v-for="(item, i) in navigation_link" :key="i">
                    <router-link class="h4 color-text-white" :to="'/rules/' + item.slug"
                                 :class="{'active-rules': $route.params.slug == item.slug || $route.name == 'pages-rules' && i == 0}">
                        {{item.title}}
                    </router-link>
                </li>
            </ul>
        </nav>
    </div>
</template>


<script>
    export default {
        data() {
            return {
                active: null,
                navigation_link: null,
                seoInfo: null
            }
        },

        created() {
            this.init();
        },

        watch: {
            $route() {
               this.metaInfo();
            }
        },

        methods: {
            init() {

                let url = '/api/rules';
                axios.get(url)
                    .then(response => {
                        this.navigation_link = response.data.rules;
                        this.seoInfo = response.data.seoInfo;
                        this.$emit('index', this.navigation_link[0].slug, this.seoInfo.seo_text);
                        this.metaInfo();
                    })
            },

            metaInfo() {
                let title = '';
                let desc = '';
                if(this.$route.path == '/rules'){
                    title = this.seoInfo?.seo_title ? this.seoInfo.seo_title : 'Условия проката в Фотопрокате "MRental"';
                    desc = this.seoInfo?.seo_desc ? this.seoInfo.seo_desc : 'Как взять технику в аренду у MRental через личный кабинет, по звонку менеджеру, или через оформления заказа в корзине. ';
                }

                this.navigation_link.forEach(item => {
                    if(item.slug ===  this.$route.params.slug) {
                        title = item.seo_title ? item.seo_title : item.title + ' в Фотопрокате MRental';
                        desc = item.seo_desc ? item.seo_desc : item.title + ' в Фотопрокате MRental. Как взять технику в аренду у MRental через личный кабинет, по звонку менеджеру, или через оформления заказа в корзине.';
                    }
                });

                document.title = title;
                document.querySelector('meta[name="description"]').setAttribute("content",  desc);
                document.querySelector('meta[name="twitter:description"]').setAttribute("content",  desc);
                document.querySelector('meta[property="og:description"]').setAttribute("content",  desc);
                document.querySelector('meta[name="twitter:text:description"]').setAttribute("content",  desc);
            }
        }
    }
</script>





